import templateUrl from './onboarding-request-review-modal.component.html';

// APEX-978 — owner-facing "Request Review" modal (mirror of the APEX-977 employee update modal).
//
// The owner picks a GROUP of forms to push back to the employee for changes and leaves a
// comment. Resolves with { option, formIds, comment }; the caller performs the push-back
// (set forms ReviewRequired + notify). Options adapt for 1099 (Federal W-9 instead of the
// W2 tax forms + I-9) via the injected `is1099` flag.
export const OnboardingRequestReviewModalComponent = {
    templateUrl,
    controller: OnboardingRequestReviewModalController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};

// Option key -> backend FormIDs (6=Profile, 5=FederalW4, -2=W9, 2=StateW4, 3=I9, 7=DirectDeposit).
//   Personal Information = profile + tax forms (+ I-9);  Tax Forms = tax forms only;  Direct Deposit = DD only;  All Forms = everything.
function buildOptions(is1099, paper) {
    // Paper apps may push back Direct Deposit only; every other group is shown but disabled.
    const dis = (value) => !!paper && value !== 'dd';
    if (is1099) {
        return [
            { value: 'personal-information', label: 'Personal Information', note: 'Profile, Federal W-9', formIds: [6, -2], disabled: dis('personal-information') },
            { value: 'tax-forms', label: 'Tax Forms', note: 'Federal W-9', formIds: [-2], disabled: dis('tax-forms') },
            { value: 'dd', label: 'Direct Deposit', note: 'Direct Deposit only', formIds: [7], disabled: dis('dd') },
            { value: 'all-forms', label: 'All Forms', note: 'Profile, Federal W-9, Direct Deposit', formIds: [6, -2, 7], disabled: dis('all-forms') }
        ];
    }
    return [
        { value: 'personal-information', label: 'Personal Information', note: 'Profile, Federal W-4, State W-4, I-9', formIds: [6, 5, 2, 3], disabled: dis('personal-information') },
        { value: 'tax-forms', label: 'Tax Forms', note: 'Federal W-4, State W-4', formIds: [5, 2], disabled: dis('tax-forms') },
        { value: 'dd', label: 'Direct Deposit', note: 'Direct Deposit only', formIds: [7], disabled: dis('dd') },
        { value: 'all-forms', label: 'All Forms', note: 'Profile, Federal W-4, State W-4, I-9, Direct Deposit', formIds: [6, 5, 2, 3, 7], disabled: dis('all-forms') }
    ];
}

function OnboardingRequestReviewModalController() {
    'ngInject';
    const vm = this;
    vm.submit = submit;
    vm.cancel = cancel;
    vm.canSubmit = canSubmit;

    vm.$onInit = function () {
        vm.is1099 = !!(vm.resolve && vm.resolve.is1099);
        vm.paper = !!(vm.resolve && vm.resolve.paper);
        vm.options = buildOptions(vm.is1099, vm.paper);
        // Paper apps can only push back Direct Deposit -> pre-select it.
        vm.choice = vm.paper ? 'dd' : null; // selected option value
        vm.comment = ''; // owner note to the employee
    };

    function canSubmit() {
        const opt = vm.options.find((o) => o.value === vm.choice);
        return !!opt && !opt.disabled;
    }

    // Finalize: resolve with the chosen group's FormIDs + comment. Caller performs the push-back.
    function submit() {
        const opt = vm.options.find((o) => o.value === vm.choice);
        if (!opt || opt.disabled) {
            return;
        }
        vm.close({
            $value: { option: opt.value, formIds: opt.formIds, comment: vm.comment }
        });
    }

    // Cancel / X aborts with zero changes.
    function cancel() {
        vm.dismiss({ $value: 'cancel' });
    }
}

// uib-modal descriptor (mirrors OnboardingUpdateModal styling/behavior).
export const OnboardingRequestReviewModal = {
    component: 'apexOnboardingRequestReviewModal',
    windowClass: 'xx-dialog pagespinner',
    size: 'md',
    backdrop: 'static',
    keyboard: false
};
